module.exports = __webpack_public_path__ + "img/1.86df194c.jpg";